import app from '@/app';
import templateUrl from './ng-main.html';

class MainController {
  constructor($http, VERSION) {
    var $ctrl = this;
    $ctrl.appVersion = VERSION;


    /*
    $ctrl.$onInit = function () {
      $http.get('version.json')
        .then(function (response) {
          $ctrl.appVersion = response.data.version;
        })
        .catch(function (error) {
          console.error(error, error);
          $ctrl.appVersion = 'Erro';
        });
    };
     */

    /*
    $ctrl.$onInit = function () {
      $http.get('assets/version.json')
        .then(function (response) {
          $ctrl.appVersion = response.data.version;
        })
        .catch(function (error) {
          console.error('Could not load version:', error);
          $ctrl.appVersion = 'N/A';
        });
    };
    */

  }
}

MainController.$inject = ['$http', 'VERSION'];

var component = {
  templateUrl,
  controller: MainController
};

app.component('prMain', component);

export default component;
